import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "../views/Login.vue";
import Store from "../store";
import { apiAccountVerify } from "../utils/request/account";
import { apiRouteVerify } from "../utils/request/route";
import { apiGetRoute } from "../utils/request/route";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login/:role?/:key?",
    name: "login",
    component: LoginView,
  },
  {
    path: "/account/register",
    name: "register",
    component: () => import("../views/Account/Register.vue"),
  },

  {
    path: "/home",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/account/manage",
    name: "manage",
    component: () => import("../views/Account/Manage"),
  },
  {
    path: "/account/changepassword",
    name: "changepassword",
    component: () => import("../views/Account/ChangePassword.vue"),
  },
  {
    path: "/periodic/INSPmaintain",
    name: "INSPmaintain",
    component: () => import("../views/Periodic/INSP_Maintain.vue"),
  },
  {
    path: "/periodic/itemupload",
    name: "itemupload",
    component: () => import("../views/Periodic/ItemUpload.vue"),
  },
  {
    path: "/periodic/review/:p",
    name: "review",
    component: () => import("../views/Periodic/Review.vue"),
  },
  {
    path: "/periodic/review/*/",
    name: "home",
    component: import("../views/HomeView.vue"),
    redirect: "home",
  },
  {
    path: "/periodic/summary",
    name: "summary",
    component: () => import("../views/Periodic/Summary.vue"),
  },
  {
    path: "/firstInspect/requirement",
    name: "requirement",
    component: () => import("../views/FirstInspect/Requirement.vue"),
  },
  {
    path: "/firstInspect/itemupload",
    name: "itemupload",
    component: () => import("../views/FirstInspect/ItemUpload.vue"),
  },
  {
    path: "/firstInspect/review/:p",
    name: "review",
    component: () => import("../views/FirstInspect/Review.vue"),
  },
  {
    path: "/firstInspect/report",
    name: "report",
    component: () => import("../views/FirstInspect/Report.vue"),
  },
  {
    path: "/*/",
    name: "login",
    component: LoginView,
    redirect: "login",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  //沒有Token跳回登入頁面
  const isLogin = window.localStorage.getItem("Token");
  if (!isLogin && to.name !== "login") {
    next("/login");
    return;
  }

  //若是轉跳至登入頁面(登出)不必驗證
  if (to.name == "login") {
    next();
    return;
  }

  //切換路由都需先驗證權限(身分及路由)
  let res2 = await apiRouteVerify(to.name, Object.values(to.params)[0]);
  if (res2 != undefined) {
    if (!res2.data) {
      next("/home");
      return;
    }
  }

  //*避免refresh後存在於vuex的值消失
  // 1.取得使用者名稱
  if (!Store.state.users.UserName) {
    let res1 = await apiAccountVerify();
    Store.commit("users/SetUserName", res1.data.userName);
    window.localStorage.setItem("Company", res1.data.company);
  }

  // 2.取得AppBar Obj
  if (Store.state.RouteItem.length == 0) {
    apiGetRoute().then((result) => {
      let main = result.data.main;
      let child = result.data.child;
      let obj = main.map((m) => ({
        MainRouteName: m.routeName,
        BaseURL: m.route,
        ChildRoute: child.filter((c) => c.mainUid == m.uid),
      }));
      Store.commit("SetRouteItem", obj);
    });
  }
  next();
});

export default router;
